import { render, staticRenderFns } from "./CurriculumUnitList.vue?vue&type=template&id=3ced8653&scoped=true&lang=pug&"
import script from "./CurriculumUnitList.vue?vue&type=script&lang=ts&"
export * from "./CurriculumUnitList.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumUnitList.vue?vue&type=style&index=0&id=3ced8653&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ced8653",
  null
  
)

export default component.exports